module.exports = __webpack_public_path__ + "ebcb6a4ae8347c16d49ba10105a79d3c.png";